import gsap from 'gsap';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    TITLE: '.js-ot-title',
    INFO: '.js-ot-info',
    HOME_LINK: '.js-ot-home-link',
};

const init = () => {
    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline
        .fromTo(ANIMATION_SELECTORS.TITLE, { opacity: 0, y: 15 }, { opacity: 1, y:0, delay: 0.5 })
        .fromTo(ANIMATION_SELECTORS.INFO, { opacity: 0 }, { opacity: 1 }, '-=0.5')
        .fromTo(ANIMATION_SELECTORS.HOME_LINK, { opacity: 0 }, { opacity: 1 }, '-=0.5');
};

const _module = { init };

export default _module;
